// components/layouts/config-view/config-detail/dashboards/DashboardFormHeader.tsx
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Dashboard } from 'states';
import { ButtonType, ButtonVariant } from 'components/core';
import styles from './../../layouts/config-view/config-detail/dashboards/ConfigLayoutDashboards.module.css';

import { IconButton } from '../buttons/IconButton';


interface DashboardFormHeaderProps {
  dashboard: Dashboard;
  isSaveDisabled: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onSave: () => void;
  /** Present only for a saved dashboard: starts saving what is on screen as a separate, new dashboard. */
  onSaveAsNew?: () => void;
}

export const DashboardFormHeader = ({
  dashboard,
  isSaveDisabled,
  isSubmitting,
  onBack,
  onSave,
  onSaveAsNew,
}: DashboardFormHeaderProps) => {
  const { t } = useTranslation();
  let dashMeta: string | null = t('DASHBOARD_HEADER.CREATED_ON', { date: moment().format('DD MMM YYYY') });
  if (dashboard.id) {
    dashMeta =
      dashboard.timestamp && dashboard.timestamp > 0
        ? t('DASHBOARD_HEADER.UPDATED_ON', { date: moment.unix(dashboard.timestamp / 1000).format('DD MMM YYYY') })
        : null;
  }

  return (
  <div className={styles.detailHeader}>
    <div className={styles.headerTop}>

      <div className={styles.headerLeft}>
        <button className={styles.backBtn} onClick={onBack} title={t('DASHBOARD_HEADER.BACK_TO_DASHBOARDS')}>
          <span className="material-icons">arrow_back</span>
        </button>
        <div className={styles.titleBlock}>
          <div className={styles.dashTitle} title={dashboard.title}>{dashboard.title}</div>
          <div className={styles.dashMeta}>
            {dashMeta}
          </div>
        </div>
      </div>

      <div className={styles.headerActions}>
        <IconButton
          icon="close"
          label={t('ACTION.CANCEL')}
          onClick={onBack}
          type={ButtonType.secondary}
          variant={ButtonVariant.outline}
          className={styles.cancelBtn}
        />
        {onSaveAsNew && (
          <IconButton
            icon="content_copy"
            label={t('DASHBOARD_HEADER.SAVE_AS_NEW')}
            onClick={onSaveAsNew}
            disabled={isSubmitting}
            type={ButtonType.secondary}
            variant={ButtonVariant.outline}
          />
        )}
        <IconButton
          icon="done"
          label={t('ACTION.SAVE')}
          onClick={onSave}
          disabled={isSaveDisabled}
          loading={isSubmitting}
          type={ButtonType.secondary}
          className={styles.saveBtn}
        />
      </div>

    </div>
  </div>
  );
};